import { RouterProvider } from 'react-router-dom';

import { QueryProvider } from '@tankef/core-react';
import { config, isDev, ENV } from '@tankef/env';
import { GtmAdapter, TelemetryProviderComponent } from '@tankef/telemetry';
import { MotionLazy, ToastContainer } from '@tankef/ui';

import '../shared/ui/navigation/progress-bar.css';
import { GlobalErrorBoundary } from './GlobalErrorBoundary';
import { router } from './router/router';
import { ThemeBootstrap } from '../providers/ThemeBootstrap';
import { useToastStore } from '../shared/feedback/api';

const telemetryConfig = {
  sentry: {
    dsn: '',
    environment: ENV,
  },
  analytics: { debug: isDev },
};

// H3: jamás inicializar GTM en builds de dev — el .env.local de los devs
// suele tener VITE_GTM_ENABLED=true con el container ID real de producción,
// contaminando GA4 con tráfico de localhost. La intención es que dev nunca
// reporte a Google. Producción y staging siguen rigiéndose por config.
const analyticsAdapters =
  config.gtm.enabled && config.gtm.containerId && !isDev
    ? [new GtmAdapter({ containerId: config.gtm.containerId, debug: false })]
    : [];

export function App() {
  return (
    <TelemetryProviderComponent config={telemetryConfig} adapters={analyticsAdapters}>
      <GlobalErrorBoundary>
        <QueryProvider>
          <MotionLazy>
            <ThemeBootstrap />
            <RouterProvider router={router} />
            <ToastContainerWrapper />
          </MotionLazy>
        </QueryProvider>
      </GlobalErrorBoundary>
    </TelemetryProviderComponent>
  );
}

function ToastContainerWrapper() {
  const toasts = useToastStore(s => s.toasts);
  const removeToast = useToastStore(s => s.removeToast);
  return <ToastContainer toasts={toasts} onClose={removeToast} />;
}
